import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=10ef101a&scoped=true"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"
import style0 from "./LocaleChanger.vue?vue&type=style&index=0&id=10ef101a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef101a",
  null
  
)

export default component.exports